// SkeletonLoader.js
import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="space-y-6">
      {/* Skeleton Loader for Product Card */}
      {[...Array(5)].map((_, index) => (
        <div key={index} className="flex flex-col animate-pulse p-1 border h-96 w-64 border-gray-200 rounded-lg shadow-md">
          {/* Image Skeleton */}
          <div className="w-full h-[80%] bg-gray-300 rounded-md"></div>
          
          {/* Text Skeleton */}
          <div className="w-full ">
            <div className="h-4 bg-gray-300 rounded w-full mt-2 mb-1"></div> {/* Title */}
            <div className="w-full flex gap-1"><span className='h-3 bg-gray-300 rounded w-1/2 my-2'></span><span className='h-3 bg-gray-300 rounded w-1/3 my-2'></span></div>  {/* Price */}
            <div className="h-4 bg-gray-300 rounded w-1/4"></div> {/* Button or Action */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
